import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { stringify } from 'query-string';
import { useCallback, useMemo } from 'react';
import ReactPaginate from 'react-paginate';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { MODAL_TYPE_CLIENT_MYPAGE_ORDER, MODAL_TYPE_CLIENT_MYPAGE_REVIEW, MODAL_TYPE_CLIENT_MYPAGE_SEND_OFF, showModal, } from '../../../../../actions/ModalActions';
import { propBool, propFunc, propNumber, } from '../../../../../helpers/custom-prop-types';
import { useUnmountRef } from '../../../../../helpers/use/useHook';
import { paginationUseCase } from '../PaginationUseCase';
import SkeletonRows from './SkeletonRows';
import SolutionRow from './SolutionRow';
const SolutionTable = (props) => {
    const { loading, onPageChange: rawOnPageChange, page } = props;
    const { orders, total } = useSelector((state) => ({
        orders: state.clientMySolution.orders[page],
        total: state.clientMySolution.ordersTotal,
    }));
    const dispatch = useDispatch();
    const rows = useMemo(() => orders || [], [orders]);
    const onClickOrder = useCallback((item) => {
        dispatch(showModal(MODAL_TYPE_CLIENT_MYPAGE_ORDER, item.id, item));
    }, [dispatch]);
    const onClickSendOff = useCallback((item) => {
        dispatch(showModal(MODAL_TYPE_CLIENT_MYPAGE_SEND_OFF, item.id, item));
    }, [dispatch]);
    const onClickReview = useCallback((item) => {
        dispatch(showModal(MODAL_TYPE_CLIENT_MYPAGE_REVIEW, item.id, item));
    }, [dispatch]);
    const unmountRef = useUnmountRef();
    const { onPageChange, skeletons } = paginationUseCase.usePagination(rawOnPageChange, rows, unmountRef);
    return (_jsxs("div", { children: [_jsxs("table", Object.assign({ className: 'solution_table_list' }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ className: 'head_title' }, { children: "\u6848\u4EF6\u540D\uFF0F\u30D5\u30A1\u30FC\u30E0\u540D" })), _jsx("th", Object.assign({ className: 'head_price' }, { children: "\u91D1\u984D\uFF0F\u671F\u9593" })), _jsx("th", Object.assign({ className: 'head_created' }, { children: "\u304A\u554F\u3044\u5408\u305B\u65E5" })), _jsx("th", Object.assign({ className: 'head_action' }, { children: "\u9078\u5B9A\u7D50\u679C" }))] }) }), _jsx("tbody", { children: (() => {
                            if (loading && rows.length === 0) {
                                return _jsx(SkeletonRows, { skeletons: skeletons });
                            }
                            if (rows.length === 0) {
                                return (_jsx("tr", Object.assign({ className: 'empty_row' }, { children: _jsxs("td", Object.assign({ colSpan: '5' }, { children: ["\u554F\u3044\u5408\u308F\u305B\u4E2D\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u4E8B\u4F8B\u306F\u3042\u308A\u307E\u305B\u3093\u3002", _jsx("br", {}), _jsx(Link, Object.assign({ to: `/consultant/search?${stringify({
                                                    keyword: '新規事業',
                                                    search: 'service',
                                                })}` }, { children: "\u307E\u305A\u306F\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u4E8B\u4F8B\u3092\u63A2\u3057\u3066\u307F\u308B" }))] })) })));
                            }
                            return rows.map((row) => (_jsx(SolutionRow, { onClickOrder: onClickOrder, onClickReview: onClickReview, onClickSendOff: onClickSendOff, row: row }, row.id)));
                        })() })] })), total > 0 && (_jsx("div", Object.assign({ className: 'react_pagination' }, { children: _jsx(ReactPaginate, { activeClassName: 'active', forcePage: page - 1, marginPagesDisplayed: 3, nextLabel: '>', onPageChange: onPageChange, pageCount: Math.ceil(total / 8), pageRangeDisplayed: 5, previousLabel: '<' }) })))] }));
};
SolutionTable.propTypes = {
    loading: propBool().isRequired,
    onPageChange: propFunc().isRequired,
    page: propNumber().isRequired,
};
export default SolutionTable;
